import React, { Component } from 'react';
import MyNavbar from '../../components/Navbar/MyNavbar';
import ClientPayment from '../../components/client/ClientPayment/ClientPayment';

export default class ClientPaymentPage extends Component {
  render() {
    return (
      <div>
      <MyNavbar />
      <ClientPayment/>
      </div>
  )
  }
}
